import {useEffect, useState} from "react";
import {FormLabel, Grid, Typography, useTheme} from "@mui/material";
import User, {MFAPreference} from "../../model/User";
import ModelCard2 from "../../components/model/ModelCard2";
import {SecurityIcon} from "../../styles/Icons";
import SecurityEditDialog from "./SecurityEditDialog";
import {phoneToNationalFormat} from "../../stores/StoreUtilities";

const SecurityCard = ({
  user,
  onSave,
}: {
  user: User
  onSave?(user: User): void
}) => {
  const [userModel, setUserModel] = useState<User>(user)
  const [title, setTitle] = useState<string>("")
  const [mfaPreference, setMfaPreference] = useState<MFAPreference>(MFAPreference.off)
  const [phone, setPhone] = useState<string>()
  const [advisorAccess, setAdvisorAccess] = useState<boolean>(false)
  const [editOpen, setEditOpen] = useState<boolean>(false)

  useEffect(() => {
    init(user)
  }, [user])

  const init = (user: User) => {
    setUserModel(user)
    setTitle("Security Settings")
    setMfaPreference(user.mfaPreference)
    setAdvisorAccess(user.advisorAccess)
    setPhone(phoneToNationalFormat(user.phone))
  }

  const theme = useTheme()

  const styles = {
    heading: {
      color: theme.palette.primary.main,
      fontWeight: 'bold'
    },
    row: {
      height: 40,
      minHeight: 40,
      maxHeight: 40,
    },
    formLabel: {
      fontSize: 12,
      fontWeight: 400,
      lineHeight: "1.0em",
      maxHeight: 15,
      marginBottom: "1px",
      textWrap: "nowrap",
      color: theme.palette.grey["700"]
    }
  }

  const renderContent = () => {
    return (
      <Grid container direction="column" spacing={0}>
        <Grid item xs={12} sx={styles.row}>
          <FormLabel sx={styles.formLabel}>Password</FormLabel>
          <Typography variant="body2">**********</Typography>
        </Grid>
        <Grid item xs={12} sx={styles.row}>
          <Grid container direction="row" spacing={0}>
            <Grid item xs={6}>
              <FormLabel sx={styles.formLabel}>Multi-Factor Auth</FormLabel>
              <Typography variant="body2">
                {mfaPreference === MFAPreference.sms ? "SMS Text" : "Off"}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <FormLabel sx={styles.formLabel}>Phone</FormLabel>
              <Typography variant="body2">
                {phone}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sx={styles.row}>
          <FormLabel sx={styles.formLabel}>Advisor Access</FormLabel>
          <Typography variant="body2">
            {advisorAccess ? "Enabled" : "Disabled"}
          </Typography>
        </Grid>
      </Grid>
    )
  }

  return (
    <ModelCard2
      icon={<SecurityIcon/>}
      title={title}
      expanded={true}
      editButtonId={`edit-btn-${userModel.id}`}
      onEdit={(event: any) => {
        setEditOpen(!editOpen)
      }}
    >
      {renderContent()}
      {editOpen &&
        <SecurityEditDialog user={userModel}
                        open={editOpen}
                          onSave={(update: User) => {
                            init(update)
                            setEditOpen(false)
                            if (onSave) {
                              onSave(update)
                            }
                          }}
                          onClose={() => {
                            setEditOpen(false)
                          }}/>
      }
    </ModelCard2>
  )
}

export default SecurityCard